/**
 * Centralized image URL helper.
 */
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
/**
 * Build the full CDN URL for a .webp image.
 */
export const getImageUrl = (fileName) => `${IMAGE_BASE_URL}webp/${fileName}.webp`;
/**
 * Build the full CDN URL for an .svg icon.
 */
export const getSvgUrl = (fileName) => `${IMAGE_BASE_URL}${fileName}.svg`;
/**
 * Build the full CDN URL for an asset in the farmer onboarding page's Farmer/ folder.
 */
export const getFarmerAssetUrl = (fileNameWithExt) => `${IMAGE_BASE_URL}Farmer/${fileNameWithExt}`;
